import { UsersImporterSaveUsersRequest, UsersImporterSlice } from '@hefe/store';
import {
  Alert,
  Button,
  Col,
  Descriptions,
  Result,
  Row,
  Space,
  Typography,
} from 'antd';
import { ResultStatusType } from 'antd/lib/result';
import { t } from '@hefe/i18n';
import React, { useState } from 'react';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../store/store';

export default function UsersImporterCheckComponent() {
  const dispatch = useAppDispatch();

  const data = useSelector(UsersImporterSlice.usersImporterDataSelector);
  const settings = useSelector(
    UsersImporterSlice.usersImporterSettingsSelector
  );
  const headers = useSelector(UsersImporterSlice.usersImporterHeadersSelector);
  const summary = useSelector(UsersImporterSlice.usersImporterSummarySelector);

  const [isImporting, setImporting] = useState(false);
  const [result, setResult] = useState(false);

  const onImport = () => {
    setImporting(true);

    const requestData: UsersImporterSaveUsersRequest = {
      data: data,
      settings: settings,
      headers: headers,
    };

    dispatch(UsersImporterSlice.importUsers(requestData))
      .unwrap()
      .then(() => setResult(true))
      .catch(() => null)
      .finally(() => setImporting(false));
  };

  const getErrorText = () => {
    const output: any[] = [];

    summary.errors.forEach((err, index) => {
      if (err.column == null) {
        let userErrors = '';
        err.errors.forEach((userError) => {
          userErrors += userError + ' ';
        });
        output.push(
          <Typography.Text key={index} style={{ margin: 0 }}>
            {err.user} + " - " + {userErrors}
          </Typography.Text>
        );
      }
    });

    return output;
  };

  if (result) {
    let status: ResultStatusType = 'success';
    if (summary.numberOfInserts === 0) {
      status = 'error';
    } else if (summary.errors.length > 0) {
      status = 'warning';
    }

    const message =
      summary.numberOfInserts +
      ' ' +
      (summary.numberOfInserts > 1 ? 'Mitglieder wurden' : 'Mitglied wurde') +
      '  importiert und - falls gewünscht - benachrichtigt!';

    if (status === 'error') {
      <Alert
        style={{ marginTop: 20, marginBottom: 20 }}
        type="error"
        message={'Beim Import kam es zu ' + summary.errors.length + ' Fehlern'}
        description={
          <Space direction="vertical" size={0}>
            {getErrorText()}
          </Space>
        }
      />;
    }

    return <Result status={status} subTitle={message} />;
  }

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Row style={{ marginBottom: 15 }}>
        <Col xs={24}>
          <Descriptions column={1} size="small" bordered>
            <Descriptions.Item label={t('users_importer.num_of_users')}>
              {data.length}
            </Descriptions.Item>
            <Descriptions.Item label={t('users_importer.auto_activate_title')}>
              {settings.sendMail ? <FaCheck /> : <FaTimes />}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
      <Row justify="end">
        <Space>
          <Button
            onClick={() =>
              dispatch(UsersImporterSlice.usersImporterActions.decrementStep())
            }
          >
            {t('prev')}
          </Button>
          <Button loading={isImporting} onClick={() => onImport()}>
            {t('import')}
          </Button>
        </Space>
      </Row>
    </Space>
  );
}
